import * as React from 'react';
export const ConfigContext = React.createContext({is_started: false});
export const VotingTimeCountdown = React.createContext(0);
